function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 4.5,
  width: 15,
  height: 14,
  rx: 1.5,
  stroke: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.22857 16H9.77143C9.89767 16 10 15.9105 10 15.8V9.02519C10 8.91473 10.1023 8.82519 10.2286 8.82519H13.7714C13.8977 8.82519 14 8.91473 14 9.02519V15.8C14 15.9105 14.1023 16 14.2286 16H15.7714C15.8977 16 16 15.9105 16 15.8V7.2C16 7.08954 15.8977 7 15.7714 7H8.22857C8.10233 7 8 7.08954 8 7.2V15.8C8 15.9105 8.10234 16 8.22857 16Z",
  fill: "#00BB77"
});
const SvgProlongationIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProlongationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/prolongation-icon.304eccfd.svg";
export { ForwardRef as ReactComponent };